/* eslint-disable react/prop-types */
import * as React from 'react';

import { Button, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { RightOutlinedIcon } from 'components';
import { cn } from 'utils';

interface PageTitleBarProps
  extends React.ComponentPropsWithoutRef<typeof Space> {
  showBackButton?: boolean;
  headerTitle: React.ReactNode;
}

const PageTitleBar = React.forwardRef<
  React.ElementRef<typeof Space>,
  PageTitleBarProps
>(
  (
    {
      showBackButton = true,
      headerTitle,
      size = 2,
      className,
      children,
      ...props
    },
    ref,
  ) => {
    const navigate = useNavigate();

    return (
      <Space ref={ref} size={size} className={cn('mb-2', className)} {...props}>
        <React.Fragment>
          {showBackButton ? (
            <Button
              type='text'
              size='small'
              icon={<RightOutlinedIcon />}
              onClick={() => navigate(-1)}
            />
          ) : null}
        </React.Fragment>
        <Typography.Title level={1} className='mb-0 text-xl'>
          {headerTitle}
        </Typography.Title>
        <React.Fragment>{children}</React.Fragment>
      </Space>
    );
  },
);
PageTitleBar.displayName = 'PageTitleBar';

export { PageTitleBar };
